export interface IBlog {
    id: number;
    date: Date;
    date_gmt: Date;
    guid: Guid;
    modified: Date;
    modified_gmt: Date;
    slug: string;
    status: string;
    type: string;
    link: string;
    title: Title;
    content: Content;
    excerpt: Excerpt;
    author: number;
    featured_media: number;
    comment_status: string;
    ping_status: string;
    sticky: boolean;
    template: string;
    format: string;
    meta: any[];
    categories: number[];
    tags: number[];
    _links: Links;  
    ThumbImage: string;
    MainImage: string;
}

export interface IOffer {
  id: number;
  date: Date;
  date_gmt: Date;
  guid: Guid;
  modified: Date;
  modified_gmt: Date;
  slug: string;
  status: string;
  type: string;
  link: string;
  title: Title;
  content: Content;
  excerpt: Excerpt;
  author: number;
  featured_media: number;
  comment_status: string;
  ping_status: string;
  sticky: boolean;
  template: string;
  format: string;
  meta: any[];
  categories: number[];
  offer_category: number[];
  tags: number[];
  _links: Links;
  ThumbImage: string;
  MainImage: string;
  acf: Acf;
}

export interface IArticle {
  id: number;
  date: Date;
  date_gmt: Date;
  guid: Guid;
  modified: Date;
  modified_gmt: Date;
  slug: string;
  status: string;
  type: string;
  link: string;
  title: Title;
  content: Content;
  excerpt: Excerpt;
  author: number;
  featured_media: number;
  comment_status: string;
  ping_status: string;
  sticky: boolean;
  template: string;
  format: string;
  meta: any[];
  categories: number[];
  offer_category: number[];
  tags: number[];
  _links: Links;
  ThumbImage: string;
  MainImage: string;
}

export interface IDriverClubNews {
  id: number;
  date: Date;
  date_gmt: Date;
  guid: Guid;
  modified: Date;
  modified_gmt: Date;
  slug: string;
  status: string;
  type: string;
  link: string;
  title: Title;
  content: Content;
  excerpt: Excerpt;
  author: number;
  featured_media: number;
  comment_status: string;
  ping_status: string;
  sticky: boolean;
  template: string;
  format: string;
  meta: any[];
  categories: number[];
  tags: number[];
  _links: Links;
  ThumbImage: string;
  MainImage: string;
}

export interface Acf {
  top_deal: boolean;
  benefit_button_link: string;
  benefit_button_text: string;
  offer_benefits: OfferBenefit[];
  offer_image: string;
}

export interface OfferBenefit {
  benefit: string;
}

export class OfferDetails {
  title: string;
  date: Date;
  detailDesc: string;
}

export class BlogDetails {
  title: string;
  date: Date;
  detailDesc: string;
}

export class DriversClubNewsDetails {
  title: string;
  date: Date;
  detailDesc: string;
}

export class ArticleDetails {
  title: string;
  date: Date;
  detailDesc: string;
}

export interface Guid {
    rendered: string;
}

export interface Title {
    rendered: string;
}

export interface Content {
    rendered: string;
    protected: boolean;
}

export interface Excerpt {
    rendered: string;
    protected: boolean;
}

export interface Self {
    href: string;
}

export interface Collection {
    href: string;
}

export interface About {
    href: string;
}

export interface Author {
    embeddable: boolean;
    href: string;
}

export interface Reply {
    embeddable: boolean;
    href: string;
}

export interface VersionHistory {
    count: number;
    href: string;
}

export interface PredecessorVersion {
    id: number;
    href: string;
}

export interface WpFeaturedmedia {
    embeddable: boolean;
    href: string;
}

export interface WpAttachment {
    href: string;
}

export interface WpTerm {
    taxonomy: string;
    embeddable: boolean;
    href: string;
}

export interface Cury {
    name: string;
    href: string;
    templated: boolean;
}
export interface Links {
    self: Self[];
    collection: Collection[];
    about: About[];
    author: Author[];
    replies: Reply[];

}



// WEBPACK FOOTER //
// ./src/app/blogs/blog.ts